export default __webpack_public_path__ + "d340d2e8868294056421a069d170d6f3.png";